module.exports = __webpack_public_path__ + "img/map_voortuin.c8a4dd3d.png";